import React from "react";
import "./Insights.css";

const insights = [
  {
    id: 1,
    title: "Latest Industrial & Structural Trends",
    desc: "Discover how engineering innovation is shaping the future of industrial construction.",
    img: "/assets/images/Structural Building.jpg",
  },
  {
    id: 2,
    title: "Modern Construction Workflow Optimization",
    desc: "Learn how advanced digital tools are transforming project planning and execution.",
    img: "/assets/images/BIMservices.jpg",
  },
  {
    id: 3,
    title: "Smart Engineering in Oil & Gas Sector",
    desc: "Exploring new methodologies and structural advancements in oil & gas engineering.",
    img: "/assets/images/Oil & Gas.png",
  },
  
];

const Insights = () => {
  return (
    <section className="insights-section">
      <h2 className="insights-title">Latest Insights</h2>

      <div className="insights-container">
        {insights.map((item) => (
          <div className="insight-card" key={item.id}>
            <img src={item.img} alt={item.title} className="insight-img" />

            <div className="insight-content">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Insights;
